import * as Yup from "yup";
export const validationSchema = Yup.object().shape({
    company_id: Yup.string().required("Company is required"),
    employee_id: Yup.string().required("Employee is required"),
    nationality_id: Yup.string().required("Nationality is required"),
    host_country_id: Yup.string().required("Host Country is required"),
    home_country_id: Yup.string().required("Home Country is required"),
    // employer_entity: Yup.string().required("Employer Entity is required"),
    assignment_type_id: Yup.string().required("Assignment Type is required"),
    assignment_start_date: Yup.string().required("Assignment Start Date is required"),
    // assignment_end_date: Yup.string().required("Assignment End Date is required"),
    immigration_status_id: Yup.string().required("Immigration Status is required"),
});

export const validationSchemaStep2 = Yup.object().shape({
    application_code: Yup.string().required("Application ID is required").max(15, "Application ID must be at most 15 characters"),
    application_visa_type_id: Yup.string().required("Visa Type is required"),
    application_country_id: Yup.string().required("Application Country is required"),
    application_submission_date: Yup.string().required("Submission Date is required"),
    application_status_id: Yup.string().required("Application Status is required"),
    application_start_date: Yup.string().required("Application Start Date is required"),
    application_expiry_date: Yup.string().required("Application Expiry Date is required"),
    // application_duration: Yup.string().required("Application Duration is required"),
    number_of_entries_id: Yup.string().required("Number of Entries is required"),
    // issuing_authority: Yup.string().required("Issuing Authority is required"),
    // reference_number: Yup.string().required("Reference Number is required").max(20, "Reference Number must be at most 20 characters"),
    // application_center: Yup.string().required("Application Center is required"),
    // case_manager: Yup.string().required("Case Manager is required"),
    // assigned_team: Yup.string().required("Assigned Team is required"),
    // client_contact: Yup.string().required("Client Contact is required"),
});